import { QueovalBase, QueovalDik, QueovalRole,eLogMode, Translation } from '../global';

export class LoginBase extends QueovalBase {
  public LoginMode: eLogMode;
  public LoginResult: LoginData;
}

// queoval / extranet

export class LoginQueovalAppModel extends LoginBase {
  public asptoken: string;    // for old login
  public appname: string;     // for old login
  public LoginStep: eLoginStep;
  
  public Username: string;
  public Password: string;
  //////public ExternalLoginData: InfoLogin;
  public LoginResultData: LoginData;
}

export class LoginExtranetAppModel extends LoginBase {
  //#region aspx webform version
  public asptoken: string;
  public appname: string;
  //#endregion

  //#region angular version
  public AppVersion: string;
  public UserName: string;
  public Password: string;
  public Source: string;
  public DataSource: string;
  public Token: string;
  //les identifiants de connexion sont Cryptage deux fois dans le cas de la connexion via mail
  public IsdoubleEncryption: boolean;

  public UserDatabaseList: Array<string>;
  //#endregion

  constructor() {
    super();
    this.IsdoubleEncryption = false;
  }
}

// webstore
export class LoginWebStoreAppModel extends LoginBase {
  public module: string;
  public sample: string;
  public start: string;
  //////public productid: string;
  public username: string;
  public password: string;
  public baseName: string;
}

// elearning / questionnaire
export class LoginCustomAppModel extends LoginBase {
  public username: string;
  public password: string;
  public datasource: string;
  //public start: string;
  public appmode: string;
  public appname: string;
  public authKeyControl: string;
  public IsdoubleEncryption: boolean;
  constructor() {
    super();
    this.IsdoubleEncryption = false;
  }
}

// estore
export class LoginEstoreAppModel extends LoginBase {
  public KeyLog: string;
  public username: string;
  public password: string;
}

export class LoginTestAppModel extends LoginBase {
  public Environment: string;
  public User: string;
  public Base: string;
  public ListUserBase: Array<QueovalDik>;
}

export class InfoUserDB {
  public Ident: string;
  public Name_SOC: string;
  public Base_SOC: string;
  public AdresSOC: string;
  public ImageSOC: string;
  public Site_SOC: string;
  public Data_SOC: string;
  public DBappSOC: string;
  public WSapiSOC: string;
  public WStreSOC: string;
  public ExSitSOC: string;
}

export class InfoLogin {
  public TokenRespondeMS: MSTokenResponse;
  public TokenRespondeGoogle: GoogleTokenResponse;

  public UserMail: string;
  public Userid: string;

  public User: string;
  public Password: string;
  public LastConnection: string;
  public ChangeLog: string;
  public DatabaseList: Array<InfoUserDB>;
  public SelectedDB: InfoUserDB;
  public FinalRedirectUrl: string;

}

export class LoginData extends QueovalBase {
  public ConnParams: QueovalParams;
  public Token: string;
  public TokenAPIAuth: string;
  public UserRole: QueovalRole;
  public TranslationData: Translation;
  public ConfigKeys: Array<QueovalDik>;
  public InfoLoginData: InfoLogin;
}

export class QueovalParams {
  public UserID: string;
  public UserName: string;
  public DataBase: string;
  public Culture: string;
  public GMT: string;
  public HttpAppLogin: string;
  public HttpServer: string;
  UrlSiteERP: string = '';
  UrlSiteERPWS: string = '';
  UrlExtranetSite: string = '';
  UrlExtranetWS: string = '';
  UrlElearningSite: string = '';
  UrlElearningWS: string = '';
  UrlQuestionnaireSite: string = '';
  UrlQuestionnaireWS: string = '';
  UrlOnlinemarketSite: string = '';
  UrlOnlinemarketWS: string = '';
  UrlPaymentWS: string = '';
  public Devise: string;
  public DestinationSite: string;
  public DestinationSiteWS: string;
  public IsAuthorizedAccess: boolean;


  public PathServer: string;
  public UTCDateTime: string;
  public ConnectionParams: ConnParams;
  public IsRestricted: boolean;
  public Google: ConnExternal;
  public MS: ConnExternal;
}

export class ConnExternal {
  public Account: string;
  public AccessToken: string;
  public RefreshToken: string;
}

export class ConnParams {
  public UserID: string;
  public UserName: string;
  public UserPswd: string;
  public DataBase: string;
  public QueovalSite: string;
  public QueovalApiService: string;
  public QueovalData: string;
  public DatabaseServer: string;
  public GoogleTokenData: GoogleTokenResponse;
  public GoogleClaims: GoogleTokenClaims;
}

export class GoogleTokenResponse {
  public access_token: string;
  public token_type: string;
  public expires_in: number;
  public id_token: string;
  public refresh_token: string;
}
export class GoogleTokenClaims {
  public aud: string;
  public iss: string;
  public email_verified: string;
  public at_hash: string;
  public azp: string;
  public email: string;
  public sub: string;
  public exp: number;
  public iat: number;
}
export class MSTokenResponse {
  public access_token: string;
  public token_type: string;
  public expires_in: number;
  public scope: string;
  public refresh_token: string;
}
export class ExternalGoogle {
  public Url: string;
  public ClientID: string;
  public ClientSecret: string;
  public RedirectUri: string;
  public ResponseType: string;
  public AccessType: string;
  public Scope: string;
  public State: string;
}
export class ExternalMS {
  public Url: string;
  public ClientID: string;
  public ClientSecret: string;
  public RedirectUri: string;
  public ResponseType: string;
  public ResponseMode: string;
  public Scope: string;
  public State: string;
}
export class ExternalLoginModel extends LoginBase {
  public Agent: string;
  public State: string;
  public Code: string;
  public LoginStep: eLoginStep;
  public Google: ExternalGoogle;
  public Microsoft: ExternalMS;
  //public ExternalLoginData: InfoLogin;
  public LoginResultData: LoginData;
}
export enum eLoginStep {
  NONE,
  STEP1,
  STEP2
}
